import { render, staticRenderFns } from "./DashboardJobsList.vue?vue&type=template&id=db68f59e&scoped=true"
import script from "./DashboardJobsList.vue?vue&type=script&lang=js"
export * from "./DashboardJobsList.vue?vue&type=script&lang=js"
import style0 from "./DashboardJobsList.vue?vue&type=style&index=0&id=db68f59e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db68f59e",
  null
  
)

export default component.exports